import { AxiosResponse } from 'axios';

import { DEFAULT_QUERY_LIMIT } from '@cvt/helpers/query';
import { camelizeObject } from '@cvt/helpers/object';
import { request } from '@cvt/clients/baseClient';
import { mapMeetingCrudData } from './meetingClient.formatter';


const apiBaseUrl = import.meta.env.VITE__CVT_API_URL;

const getMeetings = (params: Meetings.GetListParams): Promise<AxiosResponse<CVT.Query.PaginatedResults<Meetings.Meeting>>> => {
  return request({
    options: {
      url: `${apiBaseUrl}/meetings/`,
      method: 'GET',
      params: {
        search: params.search,
        status: params.status,
        tags__name: params.tags,
        date__gte: params.dateGte,
        date__lte: params.dateLte,
        limit: params.limit || DEFAULT_QUERY_LIMIT,
        offset: params.offset,
      },
    },
  }).then((data: AxiosResponse<CVT.Query.PaginatedResults<Meetings.MeetingApi>>) => ({
    ...data,
    data: {
      ...data.data,
      results: data.data.results.map(camelizeObject<Meetings.Meeting>),
    },
  }));
};

const getMeeting = (params: { id: number | string }): Promise<AxiosResponse<Meetings.Meeting>> => {
  return request({
    options: {
      url: `${apiBaseUrl}/meetings/${params.id}/`,
      method: 'GET',
    },
  }).then((data: AxiosResponse<Meetings.MeetingApi>) => ({
    ...data,
    data: camelizeObject<Meetings.Meeting>(data.data),
  }));
};

const createMeeting = (data: Partial<Meetings.Create>): Promise<AxiosResponse<Meetings.Meeting>> => {
  return request({
    options: {
      url: `${apiBaseUrl}/meetings/`,
      method: 'POST',
      data: mapMeetingCrudData(data as Meetings.Create),
    },
  }).then((data: AxiosResponse<Meetings.MeetingApi>) => ({
    ...data,
    data: camelizeObject<Meetings.Meeting>(data.data),
  }));
};

const editMeeting = (data: Partial<Meetings.Edit>): Promise<AxiosResponse<Meetings.Meeting>> => {
  return request({
    options: {
      url: `${apiBaseUrl}/meetings/${data.id}/`,
      method: 'PUT',
      data: mapMeetingCrudData(data),
    },
  });
};

const deleteMeeting = (params: { id: number | string }): Promise<AxiosResponse> => {
  return request({
    options: {
      url: `${apiBaseUrl}/meetings/${params.id}/`,
      method: 'DELETE',
    },
  });
};

export const meetingClient = {
  getMeetings,
  getMeeting,
  createMeeting,
  editMeeting,
  deleteMeeting,
};
